export default "__VITE_ASSET__B_y4KQIQ__"